// extracted by mini-css-extract-plugin
export default {"modal_wrapper_step1":"avisoTareasMantenimiento-module--modal_wrapper_step1--UdjBM","modal_small":"avisoTareasMantenimiento-module--modal_small--A3ZDz"};